import { SendMessageComponent } from './../../pages/manager/message-center/send-message/send-message.component';
import { SendMessageService } from './../../../services/sendMessage.service';
import { AppConfig } from './../../app.config';
import { AlertService } from './../../../providers/alert.service';
import { Directive, Input, HostListener } from '@angular/core';
import {
    Component,
    ViewContainerRef,
    ComponentFactoryResolver,
    AfterContentInit,
    ReflectiveInjector,
    ContentChild,
    TemplateRef
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MultiSelectModule } from 'primeng/primeng';

import * as $ from 'jquery';

@Component({
    selector: 'send-message',
    template: require('./sendmessage.html'),
    styles: [require('./sendmessage.component.scss')],
    providers: [SendMessageService]
})
export class SendMessageDilogComponent {
    constructor(
        private alert: AlertService,
        private formBuilder: FormBuilder,
        private config: AppConfig,
        private sendService: SendMessageService
    ) {}
    display: boolean = false;
    @Input('sendmsg') data: any;
    form: FormGroup = this.formBuilder.group({
        UserName: [this.config.getCurrentUser().UserName],
        Level: ['02'],
        Type: ['01'],
        Title: ['', [Validators.required]],
        Receiver: [''],
        Content: ['', [Validators.required]],
        selectUsers: []
    });
    currtype = this.form.value['Type'];
    subUserNames = [];
    defaultLabel = '选择';
    selectedItemsLabel = '{0}个选中';

    show() {
        this.display = true;
    }
    handleCancel() {
        this.display = false;
    }
    handleOk() {
        this.display = false;
    }
    //用户类型选择
    //TQQ 2017-05-10
    typeClick(type) {
        this.form.value['Type'] = type;
        this.currtype = type;
        if (this.currtype == '02' && this.subUserNames.length < 1) {
            this.getSubUserNames();
        }
    }

    //发送消息
    //TQQ 2017-05-10
    onSubmit() {
        this.alert.Loading();
        if (this.form.status == 'INVALID') {
            this.alert.errorAlert('相关信息不可为空');
            return;
        }
        this.form.value['Type'] = this.currtype;
        if (this.form.value['selectUsers']) {
            this.form.value['Receiver'] = this.form.value['selectUsers'].join(',');
        }
        this.sendService.sendMessage(this.form.value).then(s => {
            if (s['Result']) {
                this.alert.okAlert(s['Error'], '', true, null, end => {
                    this.alert.closeAllLayer();
                    this.display = false;
                    if (
                        this.data != null &&
                        this.data.callback != null &&
                        $.isFunction(this.data.callback)
                    ) {
                        this.data.callback();
                    }
                });
                this.subUserNames = [];
                this.form.setValue({
                    UserName: this.config.getCurrentUser().UserName,
                    Level: '02',
                    Type: '01',
                    Title: '',
                    Receiver: '',
                    Content: '',
                    selectUsers: []
                });
            } else {
                this.alert.errorAlert(s['Error']);
            }
        });
    }

    //获取当前用户的下级列表
    //TQQ 2017-05-26
    getSubUserNames() {
        this.sendService.getSubUserNames().then(data => {
            if (!data || data.length < 1) {
                return;
            }
            data.forEach(u => {
                this.subUserNames.push({ label: u, value: u });
            });
        });
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/shared/sendmessage/sendmessage.component.ts